/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SlotDialog/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SlotDialog({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/SlotDialog",
  isOpen,
  contentRef,
  top,
  left,
  slotDialogElementId,
  onClose
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<fromFlow.When is={isOpen}>
<div
  data-testid="SlotDialog.Vertical"
  data-view-path={viewPath}
 ref={contentRef}
 id={slotDialogElementId}
 style={{'--t-1-1dFLgU': typeof top === 'number' ? `${top}px` : top,'--l-2-1dFLgU': typeof left === 'number' ? `${left}px` : left,'--bc-3-1dFLgU': dtColorsWhite,'--pl-4-1dFLgU': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-5-1dFLgU': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-6-1dFLgU': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-7-1dFLgU': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-8-1dFLgU': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-9-1dFLgU': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-10-1dFLgU': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-11-1dFLgU': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-12-1dFLgU': dtColorsNeutral200,'--g-13-1dFLgU': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<Content
  viewPath={`${viewPath}/Content`}
 onClose={onClose}
/>
</div>
</fromFlow.When>
)}
</FloatingPortal>
{children}
</React.Fragment>)
}